export default class DuplicatedDocument {
	_id;
	_fileUUID;
	_fileName;
	_version;
	_locks;

	constructor({ id, fileUniqueId, fileName, currentVersion, locks }) {
		this.id = id;
		this.fileUUID = fileUniqueId;
		this.fileName = fileName;
		this.version = currentVersion;
		this.locks = this.createLocks(locks);
	}

	isLockedBy(lockAction) {
		return this.locks.includes(lockAction);
	}

	createLocks(locksToCreate) {
		return locksToCreate
		.map(lock => lock.toUpperCase());
	}


	get id() {
		return this._id;
	}

	set id(value) {
		this._id = value;
	}

	get fileUUID() {
		return this._fileUUID;
	}

	set fileUUID(value) {
		this._fileUUID = value;
	}

	get fileName() {
		return this._fileName;
	}

	set fileName(value) {
		this._fileName = value;
	}

	get version() {
		return this._version;
	}

	set version(value) {
		this._version = value;
	}

	get locks() {
		return this._locks;
	}

	set locks(value) {
		this._locks = value;
	}
}
